import * as iban from "iban";

export default {
  data() {
    return {
      VALIDATORS: {
        OTP: {
          name: 'otp',
          message: 'Nepravilen format dostopne kode',
          validator: (value) => {
            return (value !== undefined && typeof value === 'string' && value.length > 0 && value.length < 12);
          }
        },
        TRR: {
          name: "trr",
          message: "Nepravilen TRR (vnesite celotni TRR, npr. SI56 xxxx xxxx xxxx xxx)",
          validator: (value) => {
            return iban.isValid(value);
          },
        },
        VAT: {
          name: 'isVAT',
          message: 'Nepravilna davčna številka',
          validator: (value) => {
            if (value !== undefined && typeof value === 'string' && value.length > 0) {
              let ctrl = parseInt(value.charAt(7));
              let sum = 0;
              for (let i = 6; i >= 0; i--) {
                sum += parseInt(value.charAt(i)) * (8 - i);
              }
              let rem = sum % 11;

              if (((11 - rem) % 10) == ctrl)
                return value.length === 8;
              else
                return false;
            } else {
              return false;
            }
          }
        },
        KZZ: {
          name: "isKZZ",
          message: "Nepravilna ZZZS številka",
          validator: (value) => {
            if (!value) return false;
            if (value.length != 9) return false;
            let ctrl = parseInt(value.charAt(8));
            let sum = 0;
            let f = [6, 7, 2, 3, 4, 5, 6, 7];
            for (let i = 0; i < 8; i++) {
              sum += parseInt(value.charAt(i)) * f[i];
            }
            let rem = sum % 11;

            let ods = 11 - rem;
            if (ods >= 10) {
              ods = 0;
            }
            if (ods == ctrl) return true;
            else return false;
          }
        },
        EMAIL: {
          name: 'isEmail',
          message: 'Nepravilen e-poštni naslov',
          validator: (value) => {
            //eslint-disable-next-line
            let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regex.test(value);
          }
        },
        PHONE: {
          name: 'isPhone',
          message: 'Nepravilna telefonska številka',
          validator: (value) => {
            if (value) {
              const phoneRegex = /^[0-9]{9,}$/;
              return phoneRegex.test(value);
            } else {
              return true;
            }
          }
        }
      }
    }
  }
}
